import { Component, inject, Renderer2, RendererFactory2 } from '@angular/core'
import { DOCUMENT, NgIf } from '@angular/common'
import { ButtonComponent } from 'src/app/elements/button/button.component'
import { Environment } from 'src/environments/environment'
import { CookieStorage } from 'cookie-storage'
import { Crisp } from 'crisp-sdk-web'

declare const window: any

@Component({
  imports: [
    NgIf,
    ButtonComponent,
  ],
  selector: 'app-crisp',
  templateUrl: './crisp.component.html',
  styleUrl: './crisp.component.sass',
})
export class CrispComponent {
  protected show = false
  protected cookieStorage = new CookieStorage()
  protected renderer2: Renderer2
  protected showPreview = true
  protected document: Document

  constructor () {
    const rendererFactory = inject(RendererFactory2)
    this.renderer2 = rendererFactory.createRenderer(null, null)
    this.document = inject(DOCUMENT)

    if (this.cookieStorage.getItem('ed-chat-agreement')) {
      this.load()
    }
  }

  load () {
    if (!Environment.integrations.crisp) {
      return
    }

    this.showPreview = false
    this.cookieStorage.setItem('ed-chat-agreement', (new Date).getTime() + '', {
      path: '/',
      domain: location.host.includes('.')
        ? undefined
        : '.' + location.host.split('.').slice(-2).join('.'),
    })

    Crisp.configure(Environment.integrations.crisp.id)
  }

  loadAndOpen () {
    this.load()
    Crisp.chat.open()
  }

  toggle () {
    this.show = !this.show
  }
}
